export default {"src":"/accounts/_next/static/media/sidebar-developers.4fe17dcc.svg","height":9,"width":16,"blurWidth":0,"blurHeight":0};